import { ActionType } from 'my-constants';

export const init = data => ({ type: ActionType.INIT_DATA, data: data });
export const search = params => ({ type: ActionType.SEARCH_DATA, params: params });